import { useState } from 'react';
import { Platform, Pressable, StyleSheet, Text, View, useWindowDimensions, Linking } from 'react-native';
import { useTranslation } from 'react-i18next';
import { Ionicons } from '@expo/vector-icons';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { useTheme } from '@/contexts/ThemeContext';
import { fontSize, radius, spacing } from '@/constants/theme';

const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.heirapsia.app';
const MOBILE_WIDTH_BREAKPOINT = 768;

/** Banner μόνο στο web build (app.heirapsia.gr) όταν ανοίγει από κινητό —
 * προτείνει να κατεβάσει την εφαρμογή αντί να χρησιμοποιεί τη mobile web
 * έκδοση. Dismissible, δεν ξαναμφανίζεται μέσα στη συνεδρία μετά το κλείσιμο. */
export function MobileWebDownloadBanner() {
  const { t } = useTranslation();
  const { colors } = useTheme();
  const insets = useSafeAreaInsets();
  const { width } = useWindowDimensions();
  const [dismissed, setDismissed] = useState(false);

  if (Platform.OS !== 'web') return null;
  if (width >= MOBILE_WIDTH_BREAKPOINT) return null;
  if (dismissed) return null;

  return (
    <View style={[styles.banner, { paddingTop: insets.top + spacing.xs, backgroundColor: colors.primary }]}>
      <Ionicons name="phone-portrait-outline" size={18} color="#fff" />
      <Text style={styles.text} numberOfLines={2}>{t('mobileWebBanner.message')}</Text>
      <Pressable style={styles.cta} onPress={() => void Linking.openURL(PLAY_STORE_URL)} accessibilityRole="button">
        <Text style={styles.ctaText}>{t('mobileWebBanner.action')}</Text>
      </Pressable>
      <Pressable onPress={() => setDismissed(true)} hitSlop={10} accessibilityRole="button" accessibilityLabel={t('common.close')}>
        <Ionicons name="close" size={18} color="rgba(255,255,255,0.85)" />
      </Pressable>
    </View>
  );
}

const styles = StyleSheet.create({
  banner: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.sm,
    paddingHorizontal: spacing.md,
    paddingBottom: spacing.sm,
  },
  text: { flex: 1, color: '#fff', fontSize: fontSize.sm, fontWeight: '600' },
  cta: {
    backgroundColor: 'rgba(255,255,255,0.22)',
    borderRadius: radius.full,
    paddingHorizontal: spacing.sm,
    paddingVertical: 6,
  },
  ctaText: { color: '#fff', fontSize: 12, fontWeight: '800' },
});
